// extracted by mini-css-extract-plugin
export var inputContainer = "_sx-0";